module.exports = __webpack_public_path__ + "img/hotel-23.81bdee24.jpeg";